module.exports = __webpack_public_path__ + "img/inform-banner-img.bb259e41.png";